import { render } from "./ExpectedDelivery.vue?vue&type=template&id=61b61bf5"
import script from "./ExpectedDelivery.vue?vue&type=script&lang=js"
export * from "./ExpectedDelivery.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__